import { format, parseISO, differenceInDays } from 'date-fns';

export const formatINR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(Number(n));
};

export const formatNumber = (n) => new Intl.NumberFormat('en-IN').format(Number(n || 0));

export const fmtDate = (iso, fmt = 'dd MMM yyyy') => {
  if (!iso) return '—';
  try { return format(parseISO(iso), fmt); } catch { return iso; }
};

export const daysFromNow = (iso) => {
  if (!iso) return 0;
  try { return differenceInDays(parseISO(iso), new Date()); } catch { return 0; }
};

export const ageingColor = (bucket) => {
  switch (bucket) {
    case 'current': return 'success';
    case '0-30': return 'warning';
    case '31-60': return 'warning';
    case '61-90': return 'destructive';
    case '90+': return 'destructive';
    default: return 'muted';
  }
};

export const statusVariant = (status) => {
  const map = {
    paid: 'paid',
    due: 'due',
    partial: 'due',
    overdue: 'overdue',
    active: 'active',
    expired: 'overdue',
    terminated: 'overdue',
    occupied: 'active',
    vacant: 'due',
    submitted: 'due',
    assigned: 'active',
    in_progress: 'active',
    completed: 'paid',
    closed: 'paid',
    pending: 'due',
    approved: 'paid',
    rejected: 'overdue',
  };
  return map[status] || 'draft';
};

export const periodLabel = (period) => {
  if (!period) return '';
  const [y, m] = period.split('-');
  const d = new Date(parseInt(y), parseInt(m) - 1, 1);
  return format(d, 'MMM yyyy');
};
